/*! The $.reauthAjax function does the same thing as $.ajax, 
except that it allows the user to reauthenticate if the server returns a 401.

This script modified from retryAjax by Michael Berkompas

* jQuery.retryAjax - v0.1.0 - 2012-09-17
* https://github.com/mberkom/jQuery.retryAjax/
* Copyright (c) 2012 Michael Berkompas; Licensed MIT */

(function ($) {
    $.reauthAjax = function (ajaxParams) {
        var originalErrorCallback;
        ajaxParams.tryCount = (!ajaxParams.tryCount) ? 0 : ajaxParams.tryCount;
        ajaxParams.retryLimit = (!ajaxParams.retryLimit) ? 1 : ajaxParams.retryLimit;
        ajaxParams.suppressErrors = true;

        if (ajaxParams.error) {
            originalErrorCallback = ajaxParams.error;
        } else {
            originalErrorCallback = function () {

            };
        }

        ajaxParams.error = function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status == 401) {
                this.tryCount++;
                if (this.tryCount <= this.retryLimit) {
                    // ideally we'd refresh login and try again without user input, but there are problems with that
                    addNotification('Your login has expired. <a href="javascript:refreshLogin();">Refresh login</a> and try again.', 'alert', true, false);

                    //refreshLogin(); // refreshLogin doesn't work here; it relies on opening a new tab - new tabs get blocked unless they are directly triggered by user action
                    // fire error handling on the last try
                    //if (this.tryCount === this.retryLimit) {
                    //    this.error = originalErrorCallback;
                    //    delete this.suppressErrors;
                    //}

                    ////try again
                    //$.ajax(this);
                    return true;
                }
                return true;
            }
            else {
                originalErrorCallback(jqXHR, textStatus, errorThrown);
            }
        };

        return $.ajax(ajaxParams);
    };
}(jQuery));